import React, { Component } from 'react'
// import MainMicrosoftOfficeExcel2010 from './main_microsoft_office_excel_2010'
import { Helmet } from 'react-helmet'
import DictsInfo from '../../components/dicts_info.jsx'

// import { Link } from 'react-router-dom';
// import GambarPointer1 from './img/pointer1.png'

// function refreshPage(){
//     setTimeout(()=>{
//       window.location.reload(false);
//     }, 500);
   
//   }


export default class MengenalFungsiMatematikaDanFungsiTrigonometriPadaMsOfficeExcel2010FungsiAbsRoundUp extends Component {
  render() {
    return (
      <div>

      <Helmet>
        <title>Mengenal Fungsi Matematika Dan Trigonometri Pada Microsoft Office Excel 2010</title>
        <meta name="description" content="belajar Microsoft Office Excel 2010, tutorial Microsoft Office Excel 2010, tutorial Microsoft Excel 2010 untuk pemula, berapa bagian Microsoft Excel"/>
      </Helmet>
      
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">

              {/* <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInBottom"> */}
              <div className="col-md-9 col-md-offset-0 col-md-pull-0" >

              {/* <br/>
              <br/> */}
                  
                  
                <h1 style={{fontSize: '1.5rem'}} className="colorlib-heading">Mengenal Fungsi Matematika Dan Trigonometri Pada Microsoft Office Excel 2010</h1>

                <h2>Fungsi ROUNDUP</h2>

                <p>Apa fungsi <b>ROUNDUP</b> pada microsoft office excel 2010?</p>
                <p>Fungsi ini digunakan untuk mencari pembulatan ke atas menjauh dari arah nol.</p>
                <p>Penulisan fungsi <b>ROUNDUP</b> adalah seperti berikut:</p>               
                <p><b>=ROUNDUP(number;num_digits)</b></p>
                <div className= "w3-container" > 
                <p>Penjelasan:</p>
                    <div className= "w3-container" > 
                        <ul> 
                            <li>
                                number
                                <br/>
                                Adalah angka yang ingin dicari pembulatan ke atasnya.
                            </li> 
                            <li>
                                num_digits
                                <br/>
                                Adalah jumlah digit yang di inginkan.
                            </li>                            
                        </ul> 
                    </div>
                </div>

                <p>Contoh:</p>
                <div className= "w3-container" > 
                    <div className= "w3-container" > 
                        <ul> 
                            <li>Nilai pada sel A1 adalah 4,6.
                            <br/>
                            apabila ingin mencari nilai dengan fungsi <b>ROUNDUP</b> pada sel A3 dari sel A1, caranya adalah:
                            <br/>
                            <b>=ROUNDUP(A1;0)</b>
                            <br/>
                            apabila tekan enter maka hasilnya adalah <b>5</b>.
                            </li>
                            <br/>

                            <li>Nilai pada sel A5 adalah 59,9.
                            <br/>
                            apabila ingin mencari nilai dengan fungsi <b>ROUNDUP</b> pada sel A6 dari sel A5, caranya adalah:
                            <br/>
                            <b>=ROUNDUP(A5;0)</b>
                            <br/>
                            apabila tekan enter maka hasilnya adalah <b>60</b>.
                            </li>
                            <br/>

                            <li>Nilai pada sel A5 adalah 67896,12346.
                            <br/>
                            apabila ingin mencari nilai dengan fungsi <b>ROUNDUP</b> pada sel A6 dari sel A5, caranya adalah:
                            <br/>
                            <b>=ROUNDUP(A5;-2)</b>
                            <br/>
                            apabila tekan enter maka hasilnya adalah <b>67900</b>.
                            </li>
                            <br/>

                            <li>Contoh lain, ketikkan pada sel A5<br/>
                            <b>=ROUNDUP(123,567;2)</b>
                            <br/>
                            apabila tekan enter maka hasilnya adalah <b>123,57</b>.</li>
                        </ul> 
                    </div>
                </div>

                <br/>
                <p><b>Semoga Bermanfaat..</b></p>
               
              </div>
              <DictsInfo/>
            </div>

            {/* <div className="row row-pt-md"></div> */}

          </div>
        </section>
        {/* <MainMicrosoftOfficeExcel2010/> */}
      </div>
    )
  }
}
